import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EnvPrefixPipe } from '../../../shared/pipes/env-prefix.pipe';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/**
 * Full-screen "Updating CheckPoint…" overlay shown while the native shell
 * restarts into a downloaded live update (LiveUpdateService.restarting()).
 * Styled like the startup loader, but always shows the update message.
 */
@Component({
  selector: 'app-update-overlay',
  standalone: true,
  imports: [IconComponent, EnvPrefixPipe, TranslatePipe],
  templateUrl: './update-overlay.component.html',
  styleUrl: './update-overlay.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateOverlayComponent {}
